import { TiktokService } from "../resource";
import swal from "sweetalert2";

const PlatformModule = {
    namespaced: true,
    state: {
        datum: {},
    },
    mutations: {
     
    },
    actions: {
        
		GetOrderShippingDocument({ commit, state }, params) {
			return TiktokService.OrderPackageDocument(params);
		},

		GetPackageShippingDocument({ commit, state }, params) {
			return TiktokService.OrderPackageDocument(params);
		},
		
		SyncProduct({ commit, state }, params) {
			return TiktokService.SyncProduct(params.shop_id,params.payload);
		},

		SyncOrder({ commit, state }, params) {
			return TiktokService.SyncOrder(params.shop_id,params.payload);
		},
		ConnectPlatform({ commit, state }, params) {
			return TiktokService.ConnectPlatform(params);
		},

    },
    getters: {
     
    }
};

export default PlatformModule;
